import { useEffect, useState } from 'react'
import effects from 'app/effects/effects'
import * as R from 'ramda'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'

export default () => {
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const mapGroupCategories = (groupCategories) => {
    return R.reduce(
      (acc, groupCategory) => {
        return [
          ...acc,
          ...groupCategory.categories.data.map((category) => {
            return {
              ...category,
              categoryGroupName: groupCategory.name,
              categoryGroupID: groupCategory.id,
              optionTitle: `${groupCategory.name}/${category.name}`,
              groupBy: groupCategory.name,
            }
          }),
        ]
      },
      [],
      groupCategories,
    )
  }

  useEffect(() => {
    if (R.isEmpty(categories)) {
      setIsLoading(true)
      effects.apis
        .getGroupCategories()
        .then((response) => {
          setCategories(mapGroupCategories(response.data))
          setIsLoading(false)
        })
        .catch((error) => {
          setIsLoading(false)
          if (error && error.response && error.response.data.status !== 503) {
            dispatch(MessageAlert.showNetworkError(formatMessage)(error))
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories, setCategories])

  return {
    categories,
    isLoading,
  }
}
